import MoreVert from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useId, useState } from 'react';

import { TaskDependencyModal } from './TaskDependencyModal';

export const TaskMenu = ({ taskId }: { taskId: string }) => {
  const id = useId();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const menuOpen = Boolean(anchorEl);
  const [taskDependencyModalOpen, toggleTaskDependencyModal] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddTaskDependencyClick = () => {
    toggleTaskDependencyModal(true);
    handleClose();
  };

  return (
    <>
      <IconButton
        id={`${id}-button`}
        aria-controls={menuOpen ? id : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreVert />
      </IconButton>
      <Menu
        id={id}
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': `${id}-button`,
        }}
      >
        <MenuItem onClick={handleAddTaskDependencyClick}>
          Add task dependency
        </MenuItem>
      </Menu>
      {taskDependencyModalOpen && (
        <TaskDependencyModal
          open={taskDependencyModalOpen}
          onClose={() => toggleTaskDependencyModal(false)}
          taskId={taskId}
        />
      )}
    </>
  );
};
